import cookiesIconPKSES from 'assets/img/cookie-icon-1.png';
import cookiesIconPKID from 'assets/img/cookie-icon-2.png';
import cookiesIconEntranceAnimation from 'assets/img/cookie-icon-3.png';
import cookiesIconConsentStatus from 'assets/img/cookie-icon-4.png';

export const cookiesTableIcons = {
  _pk_ses: cookiesIconPKSES,
  _pk_id: cookiesIconPKID,
  entrance_animation: cookiesIconEntranceAnimation,
  cookieconsent_status: cookiesIconConsentStatus,
};
